import React from "react";
import { Box } from "digiwash-components";
import { Image, TouchableOpacity } from "react-native";
import Clipboard from "../Clipboard";
import { showMessage } from "react-native-flash-message";
import BoxRatio from "../BoxRatio";
import { boxRatioWidth } from "../../helpers/general";

interface PropsType {
  url: string;
  ratio: string;
  code: string;
}

function Banner(props: PropsType) {
  return (
    <Box px="xxl">
      <TouchableOpacity
        onPress={() => {
          Clipboard.setString(`${props.code}`);
          showMessage({
            message: "کد تخفیف با موفقیت کپی شد.",
            type: "success",
          });
        }}
      >
        <BoxRatio
          ratio={props.ratio}
          fixedWidth={boxRatioWidth({ columns: 1 })}
        >
          <Box
            style={{
              width: "100%",
              height: "100%",
              position: "relative",
              cursor: "pointer",
            }}
          >
            <Image
              source={{ uri: props.url }}
              resizeMode="cover"
              style={{ width: "100%", height: "100%" }}
            />
          </Box>
        </BoxRatio>
      </TouchableOpacity>
    </Box>
  );
}

export default Banner;
